import './App.scss';
import {withRouter, Switch, Route} from 'react-router-dom';
import Login from './pages/Login/Login';
import Menu from './pages/Menu/Menu';
import CreatePoll from './pages/CreatePoll/CreatePoll';
import SharePoll from './pages/SharePoll/SharePoll';
import Vote from './pages/Vote/Vote';
import Edit from './pages/EditPoll/EditPoll';
import Results from './pages/Results/Results';
import Dashboard from './pages/Dashboard/Dashboard';
import CreateAccount from './pages/CreateAccount/CreateAccount';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import "react-datepicker/dist/react-datepicker.css";
import Header from './components/Header/Header';

function App() {
  return (
        <>
        <div className="app">
            <div className="app__container">
                <div className="app__header-container">
                <Header />
                </div>
          
          <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/createaccount" component={CreateAccount} />
            <PrivateRoute path="/menu" component={Menu} />
            <PrivateRoute path="/create" component={CreatePoll} />
            <PrivateRoute path="/share/:id" component={SharePoll} />
            <PrivateRoute path="/vote" component={Vote} />
            <PrivateRoute path="/edit/:id" component={Edit} />
            <PrivateRoute path="/results/:id" component={Results} />
            <PrivateRoute path="/dashboard" component={Dashboard} />
          </Switch>
          </div>
        </div>
        </>
     
  );
}

export default withRouter(App);
